export default {
  nav: {
    home: 'Home',
    orders: 'Orders',
    accounts: 'Accounts',
    send: 'Send',
    news: 'News',
    assets: 'Assets',
    tokens: 'Tokens',
    fees: 'Fees',
    files: 'Files',
    logs: 'Logs',
    groups: 'Groups',
    settings: 'Settings'
  },
  authentication: {
    login_title: 'Account Log In',
    login_button: 'Login',
    login_button_progress: 'Logging In...',
    register_prompt: 'Don\'t have an account? Sign Up',
    register_prompt_start: 'Don\'t have an account?',
    register_prompt_end: 'Sign Up',
    login_prompt: 'Have an account? Log in ',
    register_title: 'Account Registration',
    reset_password_title: 'Reset Password',
    register_next: 'Next',
    register_button: 'Register',
    register_complete_button: 'Complete Registration',
    register_button_progress: 'Registering...',
    forgot_password_prompt: 'Forgot your password?',
    verification_incorrect: 'Incorrect verification code',
    verification_title: 'Verification',
    login: 'Log In',
    register: 'Sign Up',
    welcome_help: 'We are here to help.',
    reset_button: 'Reset Password',
    reset_button_progress: 'Resetting...',
    verification_message: 'A verification code has been sent to the email address provided, please enter the code here to reset your password.',
    verification_sms_title: 'Code Verification',
    verification_sms_message: 'A SMS containg a 6 digit code has been sent to your phone.',
    verification_sms_tips: 'Enter your verification number',
    verification_sms_progress: 'Logging you in...',
    verification_pin_title: 'PIN Verification',
    verification_pin_message: 'PIN Verification',
    verification_pin_tips: 'Enter your PIN',
    verification_pin_progress: 'Logging you in...',
    verification_password_title: 'Password Verification',
    verification_password_message: 'Password Verification',
    verification_password_tips: 'Enter your password',
    verification_password_progress: 'Logging you in...',
    verification_retry_after: 'retry after {{seconds}} seconds',
    register_create_account: 'Create a new account',
    account_recovery: 'Account Recovery',
    register_agree_terms: 'By clicking the button above, I agree',
    reset_with_security_questions: 'Reset with security questions',
    security_events_title: 'Security Events',
    security_events_text: 'Your recent security events',
    logout_session_button: 'Log Out Other Sessions',
    logout_session_button_inprogress: 'Refreshing Sessions...',
    verification_email_message: 'An mail containing a 6 digit code has been sent to you.',
    verification_totp_message: 'Please enter the code on your one time password device.',
    login_with_phone: 'Login with your phone',
    verification_new_email_sent_message: 'We have sent a verification email to your new email address.',
    home_login_prompt_start: 'Do you have an account?',
    home_login_prompt_end: 'Join our network today, be a part of the revolution.'
  },
  account: {
    accounts_title: 'My Accounts',
    summary_title: 'Total Balance',
    dashboard_title: 'Dashboard',
    dashboard_saving_usd: 'USD Savings',
    dashboard_coin_xif: 'XIF Wallet',
    dashboard_coin_eth: 'ETH Wallet',
    dashboard_coin_btc: 'BTC Wallet',
    dashboard_exchange_usd: 'Exchange USD',
    dashboard_exchange_xif: 'Exchange XIF',
    dashboard_exchange_eth: 'Exchange ETH',
    dashboard_exchange_btc: 'Exchange BTC',
    dashboard_bonus: 'Bonus',
    dashboard_wallet: 'Wallet',
    account_title: 'Account',
    account_deposit_button: 'Deposit',
    account_withdraw_button: 'Withdraw',
    account_send_button: 'Send',
    account_receive_button: 'Receive',
    account_usd_saving: 'USD Savings',
    account_xif_wallet: 'XIF Wallet',
    account_bkn_wallet: 'XIF Wallet',
    account_spn_wallet: 'SPNC Wallet',
    account_btc_wallet: 'BTC Wallet',
    account_eth_wallet: 'Ethereum Wallet',
    account_usd_exchange: 'USD Exchange',
    account_xif_exchange: 'XIF Exchange',
    account_spn_exchange: 'SPNC Exchange',
    account_eth_exchange: 'Ethereum Exchange',
    account_btc_exchange: 'Bitcoin Exchange',
    transaction_id: 'Transaction ID',
    transaction_time: 'Time Created',
    transaction_type: 'Type',
    transaction_title: 'Transaction Detail',
    transaction_status: 'Status',
    transaction_amount: 'Transaction Amount',
    transaction_from: 'From Account',
    transaction_fee: 'Transaction Fee',
    transaction_notes: 'Transaction Notes',
    address_from: 'Address From',
    address_to: 'Address To',
    transaction_details: 'Transaction Details',
    transaction_to: 'To Account',
    withdraw_title: 'Withdraw',
    withdraw_title_sub: 'Send funds to an external bank account',
    withdraw_button: 'Confirm Withdrawal',
    withdraw_button_progress: 'Transferring...',
    withdraw_name: 'Account Name',
    withdraw_number: 'Account Number',
    withdraw_swift: 'Swift Code',
    withdraw_address: 'Bank Address',
    withdraw_confirm_title: 'Withdrawal Successful',
    withdraw_fiat_confirm_message: '{{withdraw_amount}} has been withdrawn from your account. Available funds {{available_amount}}',
    withdraw_coin_confirm_message: '{{withdraw_amount}} {{symbol}} has been withdrawn from your account.',
    withdraw_confirm_button: 'Back to Accounts',
    withdraw_tip: 'Tip: You can modify bank details in settings',
    bank_verify_button: 'Verify Bank Details',
    transfer_title: 'Bank Transfer',
    deposit_title: 'Deposit',
    deposit_title_sub: 'Deposit with Credit Card',
    deposit_button: 'Confirm Deposit',
    deposit_button_progress: 'Transferring...',
    deposit_transfer_prompt: 'Transfer money from an external bank account?',
    deposit_transfer_button: 'View Transfer Instructions',
    deposit_confirm_title: 'Deposit Successful',
    deposit_confirm_message: 'has been sent to your account. Available funds',
    deposit_confirm_button: 'Back to Home',
    transfer_instructions: 'Depositing funds via bank transfer is easy. Please visit the bank institution you wish to deposit funds from. Using your bank account details listed below, funds will be transferred directly to your X Infinity Savings Account. You will be notified via email once the transaction has been processed and the funds have been deposited into your account',
    transfer_info: 'Please ensure you enter the account details correctly, if the reference number is incorrect, we will not be able to allocate your funds.',
    transfer_label_name: 'Account name',
    transfer_label_ref: 'Reference',
    transfer_label_account: 'Account number',
    transfer_label_swift: 'Swift code',
    transfer_label_address: 'Bank address',
    deposit_eth_title: 'Deposit Ethereum',
    deposit_eth_instructions: 'Depositing Ethereum via a transfer is easy. Using the account details listed below, funds will be transferred to your Ethereum address. You will be notified via email once the transaction is complete.',
    deposit_eth_info: 'Please ensure you enter the account details correctly, we will not be able to receive your funds if the details are entered incorrectly.',
    deposit_eth_address: 'My Ethereum Address',
    withdraw_eth_title: 'Withdraw Ethereum',
    withdraw_eth_instructions: 'Withdrawing Ethereum is easy. Enter your external Ethereum address below, funds will be transferred from your Ethereum address.',
    withdraw_eth_info: 'Please ensure you enter the details correctly, funds might not arrive if the details are entered incorrectly.',
    withdraw_eth_button: 'Confirm Withdrawal',
    withdraw_eth_button_progress: 'Transferring...',
    deposit_btc_title: 'Deposit Bitcoin',
    deposit_btc_instructions: 'Depositing Bitcoin via a transfer is easy. Using the account details listed below, funds will be transferred to your Bitcoin address. You will be notified via email once the transaction is complete.',
    deposit_btc_info: 'Please ensure you enter the account details correctly, we will not be able to receive your funds if the details are entered incorrectly.',
    deposit_btc_address: 'My Bitcoin Address',
    withdraw_btc_title: 'Withdraw Bitcoin',
    withdraw_btc_instructions: 'Withdrawing Bitcoin is easy. Enter your external Bitcoin address below, funds will be transferred from your Bitcoin address.',
    withdraw_btc_info: 'Please ensure you enter the details correctly, funds might not arrive if the details are entered incorrectly.',
    withdraw_btc_button: 'Confirm Withdrawal',
    withdraw_btc_button_progress: 'Transferring...',
    deposit_erc20_title: 'Deposit Erc20',
    deposit_erc20_instructions: 'Depositing token via a transfer is easy. Using the account details listed below, funds will be transferred to your token address. You will be notified via email once the transaction is complete.',
    deposit_erc20_info: 'Please ensure you enter the account details correctly, we will not be able to receive your funds if the details are entered incorrectly.',
    deposit_erc20_label_ref: 'Your X Infinity Address',
    withdraw_erc20_title: 'Withdraw Erc20',
    withdraw_erc20_instructions: 'Withdrawing your token is easy. Enter your external token address below, funds will be transferred from your token address.',
    withdraw_erc20_info: 'Please ensure you enter the details correctly, funds might not arrive if the details are entered incorrectly.',
    withdraw_erc20_button: 'Confirm Withdrawal',
    withdraw_erc20_button_progress: 'Transferring...',
    balance: 'Balance',
    withdraw_prompt_message: 'Total to be sent:{{withdraw_amount}},including a fee of {{fee}},estimate to receive:{{estimate_amount}}.',
    symbol: 'Symbol',
    account_balance: 'Account Balance',
    account_locked: 'Account Locked',
    account_available_balance: 'Available Balance',
    transactions_list: 'Transactions',
    no_accounts: 'No accounts....'
  },
  transactions: {
    exchange_bank_transfer: 'Exchange Transfer',
    bank_deposit: 'Deposit',
    transfer: 'Coin Transfer',
    transfer_generic: 'Coin Transfer',
    exchange_coin_transfer: 'Exchange Transfer',
    fee: 'Fee',
    exchange_transfer_locked: 'Exchange Transfer',
    exchange_transfer: 'Exchange Transfer',
    exchange_trade: 'Exchange Settlement',
    bank_withdraw: 'Withdraw',
    eth_withdraw: 'Withdraw',
    eth_deposit: 'Deposit',
    btc_withdraw: 'Withdraw',
    btc_deposit: 'Deposit',
    presale_transfer: 'Presale Transfer',
    xif_buy: 'Coin Purchase',
    no_transaction_found: 'No transactions yet',
    airdrop: 'Airdrop',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    recent_transactions: 'Recent Transactions',
  },
  send: {
    contacts_empty: 'No contacts yet, let\'s create a contact.',
    contacts_not_found: 'No contacts found.',
    contacts_title: 'Send Coins',
    contacts_send_to: 'Send to',
    contacts_create_title: 'Add Contact',
    contacts_create_button: 'Create Contact',
    contacts_create_button_progress: 'Creating...',
    contacts_update_title: 'Edit Contact',
    contacts_update_button: 'Update Contact',
    contacts_update_button_progress: 'Updating...',
    send_confirm_title: 'Coin Transfer Successful',
    send_confirm_message: 'coins have been sent',
    send_confirm_button: 'Back to Send',
    send_title: 'Send Coins',
    send_prompt: 'Coins to send',
    send_available_amount: 'Coins available to send',
    send_fee: 'Transfer Fee',
    send_total: 'Total To Send',
    send_button: 'Send Coins',
    send_button_progress: 'Sending...',
    scan_title: 'Scan QR',
    scan_tip: 'Scan to add a contact',
    scan_btc_tip: 'Scan a Bitcoin address using a QR code',
    scan_eth_tip: 'Scan an Ethereum address using a QR code',
    coin_not_enough: 'You do not have enough coins',
    recipient_address: 'Recipient Address',
    send_amount: 'Amount',
    send_notes: 'Notes',
    send_inc_fee: 'inc fee',
    address: 'Address',
    symbol: 'Symbol'
  },
  trade: {
    tab_buy: 'Buy',
    tab_sell: 'Sell',
    label_trade: 'Trade',
    tab_history: 'History',
    commit_title: 'Buy XIF Coins',
    commit_confirm_title: 'Order In Progress',
    commit_confirm_message_start: 'Order created to buy,order value:',
    commit_confirm_message_end: 'coins, ETH and BTC transactions will take some time, we will let you know when it is completed.',
    buy_confirm_title: 'Buy Order Created',
    buy_confirm_message_start: 'Order created to BUY',
    buy_confirm_message_end: 'Coins.',
    buy_confirm_button: 'Go to Orders',
    buy_title: 'Buy Coins',
    buy_button: 'Buy Coins',
    buy_button_progress: 'Transacting...',
    sell_confirm_title: 'Sell Order Created',
    sell_confirm_message_start: 'Order created to SELL',
    sell_confirm_message_end: 'Coins.',
    sell_confirm_button: 'Go to Orders',
    sell_title: 'Sell Coins',
    sell_button: 'Sell Coins',
    sell_button_progress: 'Transacting...',
    order_confirm_title: 'Order Created',
    order_confirm_message: 'Order created to {{order_type}} {{amount}} {{symbol}} Coins.',
    order_confirm_button: 'Back to Home',
    order_create_button: 'Create Order',
    orders_empty: 'No orders yet.',
    history_title: 'Order History',
    market_label: 'Market Prices',
    market_bid: 'Bid',
    market_ask: 'Ask',
    market_price_label: 'Price',
    coin_unit: 'Coins',
    type_buy: 'BUY',
    type_sell: 'SELL',
    status_open: 'OPEN',
    status_closed: 'CLOSED',
    status_cancelled: 'CANCELLED',
    status_pending: 'PENDING',
    status_locked: 'LOCKED',
    status_transfer: 'TRANSFER',
    cancel_button: 'Cancel Order',
    cancel_confirm_title: 'Order Cancelled',
    cancel_confirm_message: 'Your order has been cancelled.',
    cancel_confirm_button: 'Go to Orders',
    detail_title: 'Order Detail',
    detail_order: 'Order',
    detail_order_id: 'Order ID',
    detail_type: 'Type',
    detail_price: 'Price',
    detail_status: 'Status',
    detail_created: 'Time Created',
    detail_unit_price: 'Unit Price',
    detail_order_amount: 'Order Amount',
    detail_total_price: 'Total Order Price',
    detail_fees: 'Fee',
    detail_transfer_fees: 'Transfer Fee',
    detail_settle_amount: 'Settle Amount',
    detail_settle_price: 'Total Order Settle Price',
    detail_match_orders: 'Matched Orders',
    detail_transaction_hash: 'Transaction Hash',
    detail_total_settled: 'Total Settled',
    set_max_amount: 'Set Max Amount',
    bonus_purchase_msg: '5% Bonus applies to this coin purchase',
    fee_estimate_msg: 'Fee displayed above is an estimate only, actual fees depends on the BTC or ETH network and supply and demand.',
    no_orders_found: 'No orders yet',
    commit_verify_pin_button: 'verify your pin',
    commit_verify_pin_button_progress: 'verifying...',
    orders_title: 'My Orders',
    recent_orders: 'Recent Orders',
    label_total: 'Total',
    label_amount: 'Amount',
    trading_pair: 'Trading Pair',
    date_range: 'Date range'
  },
  settings: {
    home_title: 'My Settings',
    home_details_change: 'My Details',
    home_base_address: 'My {{symbol}} Address',
    home_eth_address: 'My Ethereum Address',
    home_btc_address: 'My Bitcoin Address',
    home_bank_details: 'My Bank Details',
    home_verify_id: 'Verify My ID',
    home_password_change: 'Change Password',
    home_avatar_update: 'Update Avatar',
    home_support: 'Support & Help',
    home_logout_button: 'Log Out',
    help_contact_us: 'Contact Us',
    help_contact_prefix: 'For assistance with your X Infinity wallet please email:',
    detail_title: 'My Details',
    detail_button_phone: 'Update Phone',
    detail_button: 'Update',
    detail_button_progress: 'Updating...',
    verify_email_button: 'Resend Verification Email',
    verify_email_progress: 'Sending...',
    qrcode_title: 'My {{clientname}} Wallet',
    eth_address_title: 'My Ethereum Address',
    btc_address_title: 'My Bitcoin Address',
    qrcode_tip: 'Scan this QR code to add contact or pay',
    bank_title: 'My Bank Details',
    bank_button: 'Verify Bank Account',
    bank_button_progress: 'Verifying...',
    bank_button_modify: 'Modify Bank Details',
    bank_button_modify_progress: 'Modifying...',
    bank_verify_button: 'Verify Bank Account',
    bank_verify_button_progress: 'Verifying...',
    verify_alert: 'Please upload your ID photo',
    verify_title: 'Verify My ID',
    id_verify_button: 'Upload ID',
    id_verify_button_progress: 'Uploading...',
    verify_choose_photo: 'Choose photo',
    password_title: 'Change Password',
    password_button: 'Change Password',
    password_button_progress: 'Updating...',
    avatar_title: 'Change Avatar',
    avatar_take_photo: 'Take Photo',
    avatar_choose_photo: 'Choose Photo',
    avatar_button: 'Upload new photo',
    avatar_button_progress: 'Updating...',
    bank_remove_linkedcard_button: 'Remove Linked Card',
    bank_remove_linkedcard_button_progress: 'Removing...',
    verify_confirm_title: 'Success',
    verify_confirm_button: 'Back to Home',
    bank_verify_confirm_text: 'Thank you, you have now verified your bank account',
    qrcode_incorrect: 'QR code not recognised',
    phone_change_title: 'Change Phone Number',
    phone_change_instructions: '\nPlease verify your new phone number.\n',
    phone_current_title: 'Your current number is:',
    phone_not_verified: 'Your phone number is not verified.',
    update_pin_title: 'Update Pin',
    update_pin_button: 'Update PIN',
    update_pin_button_progress: 'Updating...',
    bank_not_verified_instructions: 'Your bank details are not verified. Please enter your bank account details below.',
    bank_verifying_instructions: 'Two small deposits have been made to your bank account. Please enter these amounts below along with the refererence code provided.',
    bank_verified1_instructions: 'Your bank details are now verified.',
    bank_verified2_instructions: 'If you wish to modify your details, you will need to go through the verification process again.',
    linked_credit_card: 'Your linked credit card.',
    credit_card_num: 'Card Number: XXXXXXXXXXXX',
    credit_store_instructions: '(We do not store your card, all card details are secured with Stripe.com)',
    setting_confirm_title: 'Settings updated',
    setting_confirm_text: 'Settings updated successfully',
    setting_next_route_text: 'Back to Settings',
    setting_confirm_route_text: 'Back to Settings',
    success: 'Success',
    setting_email_sent: 'Confirmation Email Sent',
    setting_profile_updated_message: 'Profile updated successfully',
    setting_password_updated_message: 'Password updated successfully',
    email_verify_error: 'There was an error verifying your email.',
    email_verify_success: 'Your email has been successfully verified.',
    my_referrer_link: 'My Referrer Link',
    security_update_title: 'Security Settings',
    security_update_instructions: 'Change two factor verification settings',
    label_2fa_type: '2FA Type',
    label_login_2fa: 'Login 2FA',
    label_trade_2fa: 'Trade 2FA',
    label_withdraw_2fa: 'Withdraw 2FA',
    totp_settings: 'TOTP Settings',
    totp_settings_title: 'Bind Authenticator',
    totp_button: 'Bind Authenticator',
    totp_button_progress: 'Binding...',
    totp_instructions: 'Please scan the QR code above using your authenticator App. We recommend Authy or Google Authenticator. Once the QR code is scanned, create a new profile in your authenticator app, you should see a 6 digit number. Please enter the numbers in to the textbox below, wait for that number to expire, and enter the next number in to the next textbox.',
    totp_already_set_instructions: 'Your One Time Password device is already set up.',
    label_temporary_authenticator_code: 'Your temporary authenticator code',
    update_security: 'Update Security',
    update_notifications: 'Update Notifications',
    label_coin_receive: 'Coin Receive',
    label_trade_complete: 'Trade Complete',
    label_bank_withdraw: 'Bank Withdraw',
    security_events: 'Security Events',
    security_question_button: 'Set Security Questions',
    security_question_button_progress: 'Setting...',
    update_security_questions: 'Security Questions',
    set_security_questions_instructions: 'Set your security questions so you can reset your password in the future.',
    verify_phone_title: 'Verify Your Mobile',
    submit_answers_button: 'Submit Answers',
    submit_answers_button_progress: 'Submitting...',
    retrieve_questions_button: 'Retrieve Questions',
    label_answer_questions: 'Answer Security Questions',
    no_identification_uploaded: 'No identification has been uploaded.'
  },
  input_label: {
    email: 'Email',
    password: 'Password',
    password_confirm: 'Confirm Password',
    password_new: 'New Password',
    password_new_confirm: 'Confirm New Password',
    verification_code: 'Verification Code',
    firstname: 'First Name',
    lastname: 'Last Name',
    phone: 'Phone Number',
    phone_new: 'New Phone Number',
    xif_address: 'XIF Address',
    amount_USD: 'Amount in USD',
    card_name: 'Name on Card',
    card_number: 'Card Number',
    card_expiry_month: 'Exp Month (MM)',
    card_expiry_year: 'Exp Year (YYYY)',
    card_ccv: 'CCV',
    contact_name: 'Find contact',
    trade_balance: 'Available',
    trade_amount: 'Trade Amount',
    trade_unit_price: 'Unit Price',
    trade_order_value: 'Order Value',
    trade_order_fee: 'Fee (inclusive)',
    trade_market_price: 'Market Price',
    eth_address: 'Ethereum Address',
    btc_address: 'Bitcoin Address',
    notes: 'Notes',
    swift: 'Swift Code',
    verification_amount: 'Verification Amount 1',
    verification_amount_2: 'Verification Amount 2',
    verification_code: 'Verification Code',
    account_name: 'Account Name',
    account_number: 'Account Number',
    bank_address: 'Bank Address',
    verify_id_type: 'ID Type',
    verify_id_name: 'Name on ID',
    verify_id_number: 'ID number',
    verify_id_expiry: 'Expiry Date',
    verify_id_address: "Address",
    verify_type_passport: 'Passport',
    amount: 'Amount',
    referrer: 'Referrer\'s Code',
    trade_fee_estimate: 'Fee Estimate',
    pin_new: 'New PIN',
    pin_new_confirm: 'Confirm New PIN',
    ext_address: 'Address',
    question: 'Question',
    answer_to_question: 'Answer to Question',
    document_type: 'Document Type',
    bank_name: 'Bank Name',
    country_code: 'Country Code',
    currency_code: 'Currency Code',
  },
  system: {
    name: 'File Management',
    notify: 'Please verify your email',
    header_balance: 'Account Balance',
    help_title: 'Help',
    help_contents: 'Help Page',
    coming_soon: 'XIF Coin will be launched on 8th August 2018. Do check out www.xinfinity.io for more updates on the Bonus Referral Programme',
    verify_mobile: 'Get Verification Code',
    retry_verify_mobile: 'Retry number verification.',
    choose_currency: 'Choose Currency',
    delete: 'Delete',
    i_agree: 'I agree',
    terms_conditions: 'Terms & Conditions',
    and: 'and',
    privacy_policy: 'Privacy Policy',
    when_registering_an_account: 'when registering for an account',
    loading: 'loading...',
    back_to_home: 'Back to home',
    submit_verify_code: 'Submit',
    submit_verify_code_progress: 'Submitting...',
    enter_verfication_num: 'Enter your verification number',
    time: 'Time',
    agent: 'Aagent',
    search: 'Search',
    empty_data: 'no data...'
  },
  token: {
    empty_token_pairs: 'No token pairs...',
    empty_tokens: 'No tokens...',
    token_name: 'Name',
    token_listed: 'Listed',
    empty_token: 'No token info...',
    token: 'Token',
    token_list_title: 'Tokens',
    name: 'Name',
    symbol: 'Symbol',
    description: 'Description',
    asset: 'Asset',
    created: 'Created',
    modified: 'Modified',
    token_legals: 'Token Legals'
  },
  news: {
    empty_news: 'No news articles...',
    news_title: 'News',
    create_button: 'Create News',
    create_title: 'Create News',
    title: 'Title',
    summary: 'Summary',
    image: 'Image',
    content: 'Content',
    update_title: 'Update News',
    original_image: 'Original Image',
    new_image: 'New Image',
    update_button: 'Update News',
  },
  assets: {
    empty_assets: 'No assets...',
    assets_listed: 'Listed',
    assets_category: 'Category',
    assets_title: 'Assets',
    assets_create_button: 'Create Asset',
    assets_create_title: 'Create Asset',
    assets_name: 'Name',
    assets_description: 'Description',
    assets_data: 'Asset Data',
    assets_update_button: 'Update Asset',
    assets_update_title: 'Update Asset',
    assets_detail_title: 'Asset Detail',
    assets_edit_button: 'Edit Asset',
    assets_created: 'Created',
    assets_modified: 'Modified',
    assets_status: 'Status',
    assets_created_by: 'Created By',
  },
  fees: {
    fee_estimation: 'Fee Estimation (1 coin)',
    calculators: 'Calculators',
    send: 'Send',
    fee: 'Fee',
    receive: 'Receive',
    fee_estimation_instructions: 'Important Note: The fee calculations provided below are only an estimate; the actual fees may differ when the transaction takes place.'
  },
  update: {
    title: 'Update Required',
    contents: 'Please download the latest version of the APP to continue. Feel free to contact us for more information.',
  },
  errors: {
    empty_email: 'Please enter your email address',
    empty_password: 'Please enter your password',
    empty_password_confirm: 'Please re-enter your password',
    empty_firstname: 'Please enter your first name',
    empty_lastname: 'Please enter your last name',
    empty_contact_firstname: 'Please enter a first name',
    empty_contact_lastname: 'Please enter a last name',
    empty_contact_xif_address: 'Please provide a XIF contact address',
    empty_eth_address: 'Please provide a ETH address',
    empty_btc_address: 'Please provide a BTC address',
    empty_amount: 'Please enter an amount',
    empty_swift: 'Please provide your bank swift code',
    empty_account_name: 'Please provide the account name',
    empty_account_number: 'Please provide the account number',
    empty_bank_address: 'Please provide your bank address',
    empty_card_name: 'Please enter the name on the card',
    empty_card_number: 'Please provide your card number',
    empty_card_exp_month: 'Please provide card expiry month',
    empty_card_exp_year: 'Please provide card expiry year',
    empty_card_ccv: 'Please provide the card verification number',
    empty_price: 'Please provide a price',
    empty_name: 'Please provide your name',
    empty_id_number: 'Please provide ID Number',
    empty_id_expiry: 'Please provide the expiry date',
    empty_verification: 'Please provide verification code',
    empty_verification_amount: 'Please provide verification amount',
    minimum_firstname: 'First name requires at least 2 characters',
    minimum_lastname: 'Last name requires at least 2 characters',
    invalid_email: 'Please provide a valid email address',
    invalid_password: 'Password must have a minimum of 6 characters, containing at least 1 number, 1 upper case and 1 lower case',
    invalid_password_confirm: 'Passwords must match',
    invalid_password_new: 'Please set up your new password',
    invalid_amount: 'Please provide a valid amount',
    invalid_price: 'Please provide a valid price',
    invalid_card_name: 'Please provide a valid name',
    invalid_card_exp_month: 'Invalid expiry month',
    invalid_contact: 'You cannot add yourself as a contact',
    incorrect_verification_code: 'Please provide a valid verification code',
    empty_pin: "Please enter your pin code",
    empty_pin_confirm: "Please re-enter your pin code",
    invalid_pin: "PIN code must have 4 digit numbers",
    invalid_pin_confirm: "PIN code must match",
    invalid_phone_number: 'Phone number is invalid',
    commit_empty_user_pin: 'You should set your PIN before you do transactions',
  },
  file: {
    upload_button: 'Upload File',
    upload_title: 'Upload File',
    label_directory: 'Directory',
    label_file: 'File',
    label_permissions: 'Permissions',
    log_title: 'File Access Log',
    create_group_button: 'Create Group',
    create_group_button_progress: 'Creating...',
    group_list_title: 'Groups & Users',
    group_create_title: 'Create Group',
    label_name: 'Name',
    label_created: 'Created',
    group_user_title: 'Manage Group',
    label_email: 'Email',
    assign_user_button: 'Assign User to Group',
    user_group_title: 'Users in Group',
    group_edit_title: 'Group Management',
    update_group_button: 'Update Group',
    delete_group_button: 'Delete Group',
    create_directory_button: 'Create Directory',
    edit_directory_button: 'Edit Directory',
    label_total: 'Total',
    delete_group_confirm_text: 'Are you sure to delete this group ?',
    delete_file_confirm_text: 'Are you sure to delete this file ?',
    file_detail_title: 'File Detail',
    label_owner: 'Owner',
    label_size: 'Size',
    label_file_integrity: 'File Integrity',
    label_file_name: 'File Name',
    label_views: 'Views',
    label_downloads: 'Downloads',
    label_file_id: 'File ID',
    download_file_button: 'Download File',
    verify_file_button: 'Verify File',
    update_permissions_button: 'Update Permissions',
    delete_file_button: 'Delete File',
    update_permissions_title: 'Update Permissions',
    label_permission: 'Permission',
    update_button: 'Update',
    close_button: 'Close',
    file_access_title: 'File Access Log',
    edit_directory_title: 'Edit Directory',
    label_current_directory: 'Current Directory',
    delete_directory_button: 'Delete Directory',
    update_button_progress: 'Updating...',
    update_logs_title: 'Update Logs',
    create_directory_title: 'Create Directory',
    label_parent_directory: 'Parent Directory',
    create_button: 'Create',
    create_button_progress: 'Creating...',
    action: 'Action',
    log_detail_title: 'Log Details',
    label_details: 'Details',
    label_type: 'Type',
    label_ip: 'IP',
    label_agent: 'Agent',
    remove_user_confirm_text: 'Are you sure to remove user from this group ?',
    remove_button: 'remove'
  }
}
